<template>
  <div id=app>
    <div id=nav>
      <div class=nav-left>
        <div id=return-icon v-bind:class="{ hidden: this.$store.state.hideReturnIcon }" >
          <img src='img/return.png' width="28" height="28" @click="onReturnClick"/>
        </div>
        <p>{{ this.$store.state.viewTitle }}</p>
        <div id=loading-icon v-bind:class="{ hidden: this.$store.state.hideLoadingIndicator }"><img src='img/loader.gif' width="24" height="24"/></div>
      </div>
      <div class=nav-right>
        <div id=close-icon v-bind:class="{ hidden: this.$store.state.hideCloseIcon }" @click="onCloseClick"><img src='img/remove.png' width="24" height="24" /></div>
        <div id=setting-icon v-bind:class="{ hidden: this.$store.state.hideSettingIcon, rotate: !this.$store.state.hideFloatWidgetRight }" @click="onSettingClick"><img src='img/gear.png' width="24" height="24" /></div>
      </div>
    </div>
    <div id=float-widget-right v-bind:class="{ visible: !this.$store.state.hideFloatWidgetRight }">
      <div class=widget-row @click="onRefreshClick"><p>Učitaj ponovno</p></div>
     <!-- <div v-if="this.$store.state.currentView === 'flota'" class=widget-row @click="onKategorijeClick"><p>Kategorije vozila</p></div> -->
      <div class=widget-row @click="onOdjava"><p>Odjava</p></div>
    </div>
    <div id=page>
      <transition name=router-anim>
              <router-view/>
      </transition>
    </div>
    <ejs-toast ref='notification' timeOut=2500 :position="toastPosition"></ejs-toast>
    <div id="modal">
      <ejs-dialog ref="popup" isModal="true" :target='this.popup_target' :buttons='popup_buttons'  :width='this.popup_width' :content='this.popup_content' :visible="this.popup_visible">
      </ejs-dialog>
    </div>
  </div>
</template>

<style lang="scss">
body {
  margin: 0;
}

#app {
   /*font-family: Arial, Helvetica, sans-serif; */
   font-family: "Roboto", "Segoe UI", "GeezaPro", "DejaVu Serif", "sans-serif", "-apple-system", "BlinkMacSystemFont";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
}

#page {
  padding-top: 70px;
  display: block;
  width: 100%;
  
}

.page-view {
  position: relative;
  max-width: 1100px;
  margin: 0 auto 0 auto;
  min-height: calc(100vh - 70px);
}

.router-anim-enter-active {
  animation-name: custom;
  animation-duration: 0.5s;
}

.router-anim-leave-active {
  display:none;
}

@keyframes custom {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}



#nav {
  width: 100%;
  height: 50px;
  position: fixed;
  top: 0;
  left: 0;
  background-color: white;
  z-index: 1002;
  box-shadow: #c2c2c2 0px 1px 3px 1px;
}

.nav-right {
  display: flex;
  float: right;
  height: 50px;
  margin-right: 15px;
}

.nav-right img {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.nav-left {
  display: flex;
  float: left;
  height: 50px;
  margin-left: 10px;
}

.nav-left img {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 15px;
}

.nav-left p {
  font-size: 1.2rem;
  line-height: 50px;
  margin: 0;
}

#float-widget-right {
  position: fixed;
  top: 50px;
  right: 0;
  z-index: 1001;
  width: 175px;
  height: auto;
  background-color: #dadadadd;
  transform: translateX(100%);
  transition: 0.5s ease-out all;
  border-radius: 5px;
}

#float-widget-right.visible {
  transform: unset;
}

.widget-row {
  width: 100%;
  height: 50px;

  p {
    margin: 0;
    line-height: 17px;
    padding-left: 10px;
    font-weight: bold;
    position:relative;
    top: 50%;
    transform: translateY(-50%);
  }
}
.widget-row:hover {
    background-color: #aaaaaa;
}

#close-icon {
  display: block;
}

#setting-icon {
  display: block;
  transition: 0.5s ease-out all;
}

#setting-icon.rotate {
  transform: rotate(180deg);
}

#return-icon {
  display: block;

  img {
    margin:0;
    margin-right: 10px;
  }
}
#return-icon.hidden {
  display: none;
}

#close-icon.hidden {
  display: none;
}

#setting-icon.hidden {
  display: none;
}

#loading-icon {
  display: block;
}

#loading-icon.hidden {
  display: none;
}

.custom-icon-shadow {
  border-radius: 100%;
  box-shadow: 1px 2px 4px rgba(0, 0, 0, .5);
}

.e-grid {
  border: none;
}

.e-grid .e-gridheader {
  border-top: none;
}

.e-grid .e-rowcell {
  border: none;
}

.save-btn {
  width: 80%;
  max-width: 300px;
  margin-top: 10px;
  margin-bottom: 20px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}

@import "../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";
@import "../node_modules/@syncfusion/ej2-vue-inputs/styles/material.css";
@import '../node_modules/@syncfusion/ej2-buttons/styles/material.css';
@import "../node_modules/@syncfusion/ej2-vue-lists/styles/material.css";
@import "../node_modules/@syncfusion/ej2-vue-dropdowns/styles/material.css";
@import '../node_modules/@syncfusion/ej2-popups/styles/material.css';
@import "../node_modules/@syncfusion/ej2-vue-calendars/styles/material.css";
@import "../node_modules/@syncfusion/ej2-vue-notifications/styles/material.css";
</style>

<script>
export default {
  name: 'App',
  data() {
    return { 
      toastPosition: {
          X: "Center",
          Y: "Bottom"
      },
      notificationMessage: { 
        template: '' 
      },
      popup_target: "#modal",
      popup_visible: false,
      popup_width: '335px',
      popup_content: '',
      popup_buttons: [
        { click: this.popupButtonClick, 
          buttonModel: { content: 'DA'} 
        },
        { click: this.popupButtonClick, 
          buttonModel: { content: 'NE', isPrimary: true }
        }
      ],
      popup_relatedView: null     //view object of related view
    }
  },
  methods: {
    onCloseClick() {
      if (this.$store.state.previousView) {
        this.$router.push(this.$store.state.previousView);
        this.$store.state.hideCloseIcon = true;
      }
    },
    onReturnClick() {
      if (this.$store.state.previousView) {
        this.$router.push(this.$store.state.previousView);
        this.$store.state.hideReturnIcon = true;
      }
    },
    onSettingClick() {
      this.$store.state.hideFloatWidgetRight = !this.$store.state.hideFloatWidgetRight;
    },
    async onRefreshClick() {
      if(this.$store.state.currentView === 'flota') {
        if (this.$store.state.categories === null) await this.$store.dispatch('getCategories').catch(err => this.$parent.showNotification(err));
        this.$store.dispatch('getCars').catch(err => this.$parent.showNotification(err));
      }
      if(this.$store.state.currentView === 'rezervacije') this.$store.dispatch('getEventForSpecificCar', this.$store.state.selectedCar.ID).catch(err => this.$parent.showNotification(err));
      if(this.$store.state.currentView === 'kategorije') this.$store.dispatch('getCategories').catch(err => this.$parent.showNotification(err));
      this.onSettingClick();
    },
    onKategorijeClick() {
      this.$router.push('kategorije');
      this.onSettingClick();
    },
    showNotification(message) {
      this.notificationMessage.template = message || '-';
      this.$refs.notification.show(this.notificationMessage);
    },
    showPopup(relatedList, message) {
      this.popup_relatedView = relatedList;   //save view object
      this.popup_content = message || '-';
      this.$refs.popup.show();    //show popup
    },
    popupButtonClick(e) {
      let result = e.target.innerText;     //return string: DA / NE 
      if (result === 'DA') {
        if (this.popup_relatedView) this.popup_relatedView.onDelete();  //call view onDelete method
      }
      this.popup_relatedView = null;  //empty object
      this.$refs.popup.hide();  //hide popup
    },
    onOdjava() {
      this.$store.state.token = null;
      localStorage.removeItem("token");
      this.$router.push('login');
      this.onSettingClick();
    }
  },
  created() {
    if (localStorage.token) {
      this.$store.state.token = localStorage.token;
    }
    if (localStorage.rememberLogin) {
      this.$store.state.rememberLogin = localStorage.rememberLogin;
    }
  },
  mounted() {
    if (this.$store.state.token === null) this.$router.push('login') 
    else this.$router.push('flota');
  },
  watch: {
    '$route' (to, from) {
      if (to.meta.auth && this.$store.state.token === null) this.$router.push('login');
    } 
  },
}
</script>
